/**
 * Mascarade Noire — finitions premium (v2).
 * - Apparition en cascade des grilles produits (transform + opacity uniquement)
 * - Titre du hero qui se révèle mot à mot
 * - Avis clients : « Voir plus d'avis »
 * - En-tête : ombre discrète une fois la page défilée
 * Tout est désactivé si l'utilisateur demande moins d'animations. Sans
 * JavaScript, le contenu reste entièrement visible (les classes d'animation
 * ne sont ajoutées que par ce script).
 */
(function () {
  'use strict';

  function reducedMotion() {
    if (document.documentElement.getAttribute('data-mn-reduced-motion') === 'true') return true;
    try {
      var stored = localStorage.getItem('mn-reduced-motion');
      if (stored === 'true') return true;
      if (stored === 'false') return false;
    } catch (e) {}
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ---------- Apparition en cascade ---------- */
  var REVEAL_SELECTOR = [
    '.product-grid__item',
    '.resource-list__item',
    '.mn-beast-card',
    '.mn-avis-card',
    '.mn-trust__item',
  ].join(',');

  var revealObserver = null;

  function setupReveal(fromMutation) {
    if (reducedMotion() || !('IntersectionObserver' in window)) return;
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -30px 0px' }
      );
    }

    var items = document.querySelectorAll(REVEAL_SELECTOR);
    var perParent = new Map();
    items.forEach(function (el) {
      if (el.classList.contains('mn-js-reveal') || el.dataset.mnSeen === 'true') return;
      el.dataset.mnSeen = 'true';
      // Déjà à l'écran au premier chargement : on laisse tel quel (pas de flash).
      var rect = el.getBoundingClientRect();
      if (!fromMutation && rect.top < window.innerHeight * 0.9 && rect.bottom > 0) return;
      var parent = el.parentElement;
      var index = perParent.get(parent) || 0;
      perParent.set(parent, index + 1);
      el.style.setProperty('--mn-i', String(index % 4));
      el.classList.add('mn-js-reveal');
      revealObserver.observe(el);
    });
  }

  /* ---------- Titre du hero mot à mot ---------- */
  function setupHeroWords() {
    if (reducedMotion()) return;
    // Uniquement le grand titre de la page d'accueil (jamais le titre d'un produit).
    var main = document.querySelector('main[data-template]');
    if (!main || main.getAttribute('data-template') !== 'index') return;
    var hero = main.querySelector('.shopify-section:first-child');
    if (!hero) return;
    var heading = hero.querySelector('h1, h2');
    if (!heading || heading.dataset.mnWords === 'true') return;
    // On ne touche qu'à du texte simple (pas de balises imbriquées).
    if (heading.children.length > 0) return;
    var text = heading.textContent.trim();
    if (!text) return;
    heading.dataset.mnWords = 'true';
    heading.setAttribute('aria-label', text);
    heading.textContent = '';
    text.split(/\s+/).forEach(function (word, i, all) {
      var span = document.createElement('span');
      span.className = 'mn-hero-word';
      span.setAttribute('aria-hidden', 'true');
      span.style.setProperty('--mn-w', String(i));
      span.textContent = word;
      heading.appendChild(span);
      if (i < all.length - 1) heading.appendChild(document.createTextNode(' '));
    });
  }

  /* ---------- Avis clients : voir plus ---------- */
  function setupReviewsMore() {
    document.querySelectorAll('[data-mn-avis-list]').forEach(function (list) {
      if (list.dataset.mnMore === 'true') return;
      var cards = list.querySelectorAll('.mn-avis-card');
      var VISIBLE = 6;
      if (cards.length <= VISIBLE) return;
      list.dataset.mnMore = 'true';
      cards.forEach(function (card, i) {
        if (i >= VISIBLE) card.hidden = true;
      });
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'button-secondary mn-avis__more';
      btn.textContent = "Voir tous les avis (" + cards.length + ')';
      btn.addEventListener('click', function () {
        cards.forEach(function (card) {
          card.hidden = false;
        });
        btn.remove();
        if (cards[VISIBLE]) {
          cards[VISIBLE].setAttribute('tabindex', '-1');
          cards[VISIBLE].focus({ preventScroll: false });
        }
      });
      list.appendChild(btn);
    });
  }

  /* ---------- En-tête : état « défilé » ---------- */
  function setupHeaderState() {
    var header = document.querySelector('#header-component');
    if (!header) return;
    var wrapper = document.querySelector('.page-wrapper');
    var ticking = false;
    function currentScroll() {
      if (wrapper && wrapper.scrollTop > 0) return wrapper.scrollTop;
      return window.scrollY || document.documentElement.scrollTop || 0;
    }
    function update() {
      header.classList.toggle('mn-header--scrolled', currentScroll() > 12);
      ticking = false;
    }
    document.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true, capture: true }
    );
    update();
  }

  function boot() {
    setupHeroWords();
    setupReveal();
    setupReviewsMore();
    setupHeaderState();

    // Les grilles filtrées / paginées sont re-rendues par le thème : on
    // réapplique l'effet aux nouveaux éléments.
    if ('MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function (mutations) {
        if (pending) return;
        // On ne réagit qu'à l'arrivée de nouvelles cartes (pas aux compteurs, etc.).
        var relevant = mutations.some(function (m) {
          return Array.prototype.some.call(m.addedNodes, function (n) {
            return (
              n.nodeType === 1 && (n.matches(REVEAL_SELECTOR) || !!n.querySelector(REVEAL_SELECTOR))
            );
          });
        });
        if (!relevant) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          setupReveal(true);
        });
      }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
